// extracted by mini-css-extract-plugin
module.exports = {"chainSlider":"chain-slider-module--chain-slider--BRnYa"};